import ProductGroupsView from './ProductGroupsView';

const views = {
  ProductGroupsView,
};
export default views;
